export default __webpack_public_path__ + "static/media/career_growth.9b6e34ac.png";